<template>
  <div class="h-screen bg-white w-full">
    <div class="w-full bg-gray-900 py-10 relative">
      <svg
        class="absolute top-0 right-0 m-4 w-6 h-6 text-white"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M4 6h16M4 10h16M4 14h16M4 18h16"
        ></path>
      </svg>

      <div class="h-20 w-20 mx-auto relative">
        <div
          class="h-6 w-6 items-center flex absolute bottom-0 right-0 rounded-full bg-primary text-white"
        >
          <svg
            class="w-4 h-4 mx-auto"
            fill="currentColor"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
            ></path>
          </svg>
        </div>
        <img
          v-if="card.avatar"
          class="rounded-full h-20 w-20 shadow mx-auto object-cover"
          :src="card.avatar"
          alt="Profile Image"
        />

        <img
          v-else
          class="rounded-full h-20 w-20 shadow mx-auto object-cover"
          src="data:image/jpeg;base64,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"
          alt="Profile Image"
        />
      </div>

      <h2 class="mt-6 text-white header-heavy tracking-tight text-xl">
        {{ card.name }}
      </h2>
      <h2 class="text-white header text-base">
        <svg
          class="w-5 h-5 inline-block text-gray-700"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
            clip-rule="evenodd"
          ></path>
        </svg>
        {{ card.address.locality }}
      </h2>
      <h2 class="text-white header text-base">
        <i class="fa-solid fa-phone text-gray-700"></i>
        {{ card.phone }}
      </h2>
      <h2 class="text-white header text-base">
        <i class="fa-solid fa-envelope text-gray-700"></i>
        {{ card.email }}
      </h2>
    </div>

    <div class="relative h-full bg-gray-200 rounded-t-xl">
      <div
        class="w-full h-14 bg-gray-800 border-b border-gray-300 flex items-center justify-center px-4"
      >
        <i class="fa-solid fa-calendar inline-block mr-1 text-gray-600"></i>
        <datetime
          v-model="date"
          type="date"
          input-class="rounded text-center text-lg h-12 bg-gray-700 outline-none px-2 text-gray-300"
          class="theme-orange"
        ></datetime>
      </div>
      <div class="relative h-full bg-gray-200 rounded-t-xl flex">
        <div class="w-full  overflow-y-scroll">
          <div class="w-full flex" v-for="(j, index) in jobs" :key="index">
            <div class="flex-shrink">
              <div
                class="w-16 mt-0 lg:mt-10 h-full bg-white bg-opacity-50 rounded-tl-lg"
              >
                <div
                  class="h-full items-center flex w-16 justify-center items-center text-xs header-heavy border-b border-gray-300"
                >
                  {{ j.startTime }}
                </div>
              </div>
            </div>
            <div class="flex-grow p-4 flex flex-wrap">
              <div
                class="w-full flex"
                v-for="(job, jIndex) in j.jobs"
                :key="'J' + jIndex"
              >
                <div
                  @click="showWorkCard(job)"
                  :class="jobStyles(job)"
                  class="flex relative w-full bg-white space-x-2 items-center rounded p-2 text-left"
                >
                  <div class="absolute top-0 right-0 mr-1">
                    <span class="header-bold" style="font-size: 9px">{{
                      job.status
                    }}</span>
                  </div>
                  <div v-if="job.contractor" class="flex-shrink">
                    <img
                      v-if="job.contractor.avatar"
                      :src="job.contractor.avatar"
                      class="w-12 h-12 rounded-full object-cover border-2 border-white"
                    />
                    <img
                      src="https://avatarairlines.com/wp-content/uploads/2020/05/Male-placeholder.jpeg"
                      alt="avatar"
                      class="w-12 h-12 rounded-full object-cover border-2 border-white"
                    />
                  </div>
                  <div v-if="!job.contractor" class="flex-shrink">
                    <i class="fa-solid fa-ban"></i>
                  </div>
                  <div class="flex-grow">
                    <div class="w-full">
                      <h2 class="header-bold text-sm truncate">
                        {{ job.company }}
                      </h2>
                    </div>
                    <h2 class="text-xs truncate">
                      {{ job.address.street_number }} {{ job.address.route }},
                      {{ job.address.locality }}
                    </h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="selectedJob"
      @click="saveJob()"
      style="z-index: 99999999999999999999999999"
      class="w-full header-bold bg-primary text-white h-20 fixed bottom-0 left-0 flex items-center justify-center"
    >
      Assign To Job
    </div>
  </div>
</template>

<script>
import { bus } from "../../main";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { getJobsByDateAndContractor, putFire } from "../../firestore/utils";
import { getTimeStamp } from "../../firebase";

export default {
  props: ["card", "selectedJob", "date"],
  data() {
    return {
      jobs: [],
    };
  },
  methods: {
    async saveJob() {
      await putFire({
        collection: "jobs",
        doc: this.selectedJob.id,
        body: {
          contractor: this.card,
        },
      });

      bus.$emit("showWorkCardFunc", false);
      bus.$emit("loadOwnerCardFunc", false);
      bus.$emit("showContractorCardFunc", false);
      bus.$emit("refreshHome");
      // bus.$emit("switchOwner", false);
    },
    showWorkCard(i) {
      // Only make workCard clickable if selectedJob is false - we in that case
      // we already have a workcard loaded - prevent infinate nesting
      if (!this.selectedJob) {
        bus.$emit("loadOwnerCardFunc", false);
        bus.$emit("showWorkCardFunc", i);
      }
    },
    jobStyles(job) {
      if (job.contractor && job.status == "ON-CALL")
        return "bgyellowstripes text-white bg-yellow-600";
      if (job.contractor && job.status == "FIRM")
        return "bggreenstripes text-white bg-green-600";
      if (job.contractor && job.status == "CANCELLED")
        return " text-gray-600 bg-gray-100";
      if (!job.contractor) return "bgredstripes text-white bg-red-900";
    },
    async getItems() {
      const start = this.$moment(this.date).startOf("day");
      const end = this.$moment(this.date).endOf("day");

      const _jobs = await getJobsByDateAndContractor({
        collection: "jobs",
        dateFrom: getTimeStamp(new Date(start)),
        dateTo: getTimeStamp(new Date(end)),
        contractorId: this.card.id,
      });
      this.formatJobs(_jobs);
    },
    formatJobs(_jobs) {
      let arr = [];
      for (let i = 0; i < _jobs.length; i++) {
        const startTime = this.$moment(_jobs[i].date.seconds * 100).format(
          "HH:mmA"
        );
        const timeExists = arr.filter((i) => {
          i.startTime == startTime;
        });
        if (timeExists.length > 0) {
          arr[timeExists].jobs.push(_jobs[i]);
        } else {
          arr.push({
            startTime: startTime,
            jobs: [_jobs[i]],
          });
        }
      }

      this.jobs = arr;
    },
  },
  created() {
    this.getItems();
  },
  components: {
    Datetime,
  },
};
</script>
